import { render, staticRenderFns } from "./PeriodItemNew.vue?vue&type=template&id=65e01f2f&scoped=true&"
import script from "./PeriodItemNew.vue?vue&type=script&lang=js&"
export * from "./PeriodItemNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e01f2f",
  null
  
)

export default component.exports